export default "__VITE_ASSET__DK8YEIbs__"